module.exports = __webpack_public_path__ + "static/img/104946.fedca85e.png";